import { render } from "./LotDocuments.vue?vue&type=template&id=4e149491&scoped=true&ts=true&lang=pug"
import script from "./LotDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./LotDocuments.vue?vue&type=style&index=0&id=4e149491&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e149491"]])

export default __exports__